import { useDispatch, useSelector } from 'react-redux'
import { useCallback, useEffect } from 'react'
import { TalkChannelList } from 'features/talkChannelRegister/TalkChannelList'
import PropTypes from 'prop-types'
import LoadingWrapper from 'components/loading/LoadingWrapper'
import { failWithErrorResponse } from 'features/toast/Toast'
import {
  fetchTalkChannels,
  mapTalkChannels,
  reset,
  setBizChannelId,
  toggleAccountTalkChannel,
} from 'features/talkChannelRegister/talkChannelRegisterSlice'
import { ConfirmModal } from 'components/dialog/ModalTemplate'
import { isEmpty } from 'utils'
import { fetchChannels } from 'features/channel/list/channelListSlice'
import { useUpdatingRef } from 'utils/hooks/useUpdatingRef'

export const TalkChannelRegisterPopup = ({
  bizChannelId,
  handleClose,
  handleShowNoChannelsAvailable,
}) => {
  const dispatch = useDispatch()
  const handleCloseRef = useUpdatingRef(handleClose)
  const handleShowNoChannelsAvailableRef = useUpdatingRef(
    handleShowNoChannelsAvailable
  )
  const { isLoading, accountTalkChannels } = useSelector(
    state => state.talkChannelRegister
  )

  const initPopup = useCallback(async () => {
    dispatch(setBizChannelId(bizChannelId))
    const { error, payload } = await dispatch(fetchTalkChannels())
    if (error) {
      failWithErrorResponse(payload)
      handleCloseRef.current()
    } else if (isEmpty(payload)) {
      handleCloseRef.current()
      handleShowNoChannelsAvailableRef.current()
    }
  }, [bizChannelId, dispatch, handleCloseRef, handleShowNoChannelsAvailableRef])

  const handleConfirm = async ({ preventClose }) => {
    const { error, payload } = await dispatch(mapTalkChannels())
    if (error) {
      preventClose()
      failWithErrorResponse(payload)
      // 일부만 실패할 수도 있으므로 상태관리를 단순히 하기 위해 처음부터 다시 시작한다.
      reset()
      initPopup()
    } else {
      dispatch(fetchChannels())
    }
  }

  useEffect(() => {
    initPopup()
    return () => dispatch(reset())
  }, [dispatch, initPopup])

  return (
    <ConfirmModal
      title="카카오톡 채널 등록"
      handleClose={handleClose}
      onCancel={null}
      onConfirm={handleConfirm}>
      <p className="subtit_layer">최대 2개 채널 연동 가능합니다.</p>
      <LoadingWrapper isLoading={isLoading}>
        <TalkChannelList
          kakaoTalkChannels={accountTalkChannels}
          handleToggleChannel={uuid => dispatch(toggleAccountTalkChannel(uuid))}
          isEditable
          changeLayoutClass={false}
        />
      </LoadingWrapper>
    </ConfirmModal>
  )
}

TalkChannelRegisterPopup.propTypes = {
  bizChannelId: PropTypes.string,
  kakaoTalkChannels: PropTypes.any,
  handleToggleChannel: PropTypes.func,
  handleClose: PropTypes.func,
  handleShowNoChannelsAvailable: PropTypes.func,
}
